import { createEvent, restore, sample } from 'effector'

import { Permission, PermissionsRequest, PermissionsResponse } from './types'
import {
  isAllElementsOfSearchTextNotExist,
  mapSearchText,
} from '../../../../libs/utils'
import { fx } from '../../../../libs'

export const permissionListMounted = createEvent<PermissionsRequest>()

export const getPermissions = fx<PermissionsRequest, PermissionsResponse>({
  method: 'GET',
  url: `/permission`,
})

export const $permissions = restore<Permission[]>(
  getPermissions.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfPermissions = restore(
  getPermissions.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: permissionListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] = `${
            filters[key as keyof typeof filters]
          }`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getPermissions,
})
